import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, toastEmitter } from "@anchor/react-components";
import Table from '@anchor/react-components/dist/lib/components/TableV2/Table'
import CONSTANTS from './SubscriptionConstants.js';
import { accessRequest } from './authConfig';
import useFetchWithMsal from './hooks/useFetchWithMsal';

function SubscriptionRuleTable({ code1, code2, value, linkedCode, counter }) {
    const { error, execute } = useFetchWithMsal(accessRequest);

    console.log('code1:' + code1 + ', code2:' + code2 + ', value:' + value + ', linkedCode:' + linkedCode + ', counter:' + counter);

    const [data, setData] = useState('');
    const [selRec, setSelRec] = useState('');
    const [showDeleteModal, setDeleteModal] = useState('');

    const boxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        flexDirection: "column",
        width: "100%", // Set width to 100%
        background: "#fff",
        marginTop: "20px",
    };

    const tableColumns = [
        {
            slotKey: 'ruleId',
            title: 'Rule Id',
        },
        {
            slotKey: 'code1',
            title: 'Code 1',
        },
        {
            slotKey: 'code2',
            title: 'Code 2',
        },
        {
            slotKey: 'value',
            title: 'Value',
        },
        {
            slotKey: 'type',
            title: 'Type',
        },
        {
            slotKey: 'linkedCode',
            title: 'Linked Code',
        }
    ];
    const fetchData = async () => {
        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionRule/getAllRules?code1=` + code1 + `&code2=` + code2 + `&value=` + value + `&linkedCode=` + linkedCode;
            console.log(urlstr);

            execute("GET", urlstr).then((response) => {

                if (response) {
                    let jsonArray = response;
                    for (let i = 0; i < jsonArray.length; i++) {
                        let obj = jsonArray[i];
                        Object.keys(obj).map(function (key, index) {
                            if (key === 'linkedCode' && obj[key] == null) {
                                obj[key] = { code: '<Null>' };
                            }
                        });
                    }
                    console.log(jsonArray);
                    setData(jsonArray);
                }
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [counter, execute]);

    const handleDeleteButtonClick = async () => {
        console.log('Selected Records: ' + selRec);
        let ids = '';
        for (let i = 0; i < selRec.length; i++) {
            ids += selRec[i].ruleId + ',';
        }

        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionRule/delete?ids=` + ids;
            console.log(urlstr);

            execute("DELETE", urlstr).then((response) => {
                if (response) {
                    console.log('response.status: ' + response.status);
                    console.log('response.message: ' + response.message);
                    if (response.status === 'OK' || response.status === 'CONFLICT') {
                        let respText = response.message;
                        if (response.status === 'OK') {
                            toastEmitter({ "title": "SUCCESS", "description": respText }, { position: 'top-center' });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": respText }, { position: 'top-center', type: "error" });
                        }
                        setSelRec('');
                        fetchData();
                    } else {
                        if (response.status === 403) {
                            toastEmitter({ "title": "ERROR", "description": 'You are not authorized to delete Subscription Rule(s).' }, { position: 'top-center', type: "error" });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": 'Error occurred while deleting Subscription Rule(s)' }, { position: 'top-center', type: "error" });
                        }
                    }
                }
            });

        } catch (error) {
            console.error("Error occurred while delete Subscription Rule:", error);
        }
        setDeleteModal('')
    }

    return (
        <div >
            <div >
                <Table
                    stickyHeader
                    maxHeight={350}
                    defaultColumns={tableColumns}
                    gridLine="both"
                    primaryKey="codeId"
                    fit="small"
                    tableWidth="full-width"
                    columnData={[
                        {
                            accessorKey: 'ruleId',
                            header: 'Rule Id',
                            id: 'ruleId',
                        },
                        {
                            accessorKey: 'code1.code',
                            alignData: 'right',
                            header: 'Code 1',
                            id: 'code1',
                        },
                        {
                            accessorKey: 'code2.code',
                            alignData: 'right',
                            header: 'Code 2',
                            id: 'code2',
                        },
                        {
                            accessorKey: 'value',
                            alignData: 'right',
                            header: 'Value',
                            id: 'value',
                        },
                        {
                            accessorKey: 'linkedCode.code',
                            alignData: 'right',
                            header: 'Linked Code',
                            id: 'linkedCode',
                        }
                    ]}
                    defaultData={data}
                    onInputChange={function noRefCheck() { }}
                    onPageChange={function noRefCheck() { }}
                    onPageSizeOptionsChange={function noRefCheck() { }}
                    onRowClickCallback={function noRefCheck() { }}
                    onRowExpandedCallback={function noRefCheck() { }}
                    onRowSelection={function noRefCheck(e) {
                        setSelRec(e);
                    }}
                    onSorting={function noRefCheck() { }}
                    rowSelector={[
                        {
                            id: 'customSelect'
                        }
                    ]}
                />
            </div>
            <div style={boxStyle} >
                <Button
                    disabled={selRec.length === 0}
                    appearance="default"
                    id="primary2"
                    label="DELETE"
                    width="49"
                    name="primary2"
                    onClick={function noRefCheck() {
                        setDeleteModal(true)
                    }}
                    title="DELETE"
                    variant="filledAlt"
                    fit="small"
                />
                <Modal
                    actions={{
                        primaryAction: <Button variant="filledAlt" label="Yes, Delete" onClick={handleDeleteButtonClick} />,
                        tertiaryAction: <Button label="Cancel" onClick={function noRefCheck() { setDeleteModal('') }} variant="outlined" />
                    }}
                    heading="Alert"
                    dimension="small"
                    open={showDeleteModal}
                    showCloseIcon
                    onClose={function noRefCheck() { setDeleteModal('') }}
                >
                    <p>
                        Are you sure, you want to delete {selRec.length} subscription rule(s)?
                    </p>
                </Modal>
            </div>
        </div>
    );
}

export default SubscriptionRuleTable;
